import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import { DataFormatter } from "../../ui/dataFormatter";

let style = Object.assign({}, global);

const SignatureStatusModal = props => {
  const { isDocumentSigned } = useContext(EditorContext);

  const [totalSigner, setTotalSigner] = useState();
  const [signedSigner, setSignedSigner] = useState();

  //Function for close modal
  const closeModal = () => {
    props.setShowModal(!props.showModal);
  };

  useEffect(() => {
    let signedSignerList = [];
    props.signerList.forEach(signer => {
      if (signer.status === "signed") signedSignerList.push(signer._id);
    });

    setTotalSigner(props.signerList.length);
    setSignedSigner(signedSignerList.length);
  }, []);

  return (
    <React.Fragment>
      <span aria-label="Close" className={cx(style["cross-modal"], style["rounded"])} onClick={closeModal}>
        <Icon icon="ui-close" />
      </span>

      {isDocumentSigned === "partial" && (
        <div
          className={cx(
            style["text-center"],
            style["d-flex"],
            style["flex-column"],
            style["align-items-center"],
            style["mt-n2"]
          )}>
          <div className={cx(style["greenBox-icon"], style["mb-3"])}>
            <span>
              {signedSigner}/{totalSigner}
            </span>
          </div>
          <h4 className={cx(style["fw-7"], style["mb-4"])}>The Document is Partially Accepted</h4>
          <p className={style["font-15"]}>
            The document is locked and can’t be edited. The viewers can still access the published page.
          </p>
        </div>
      )}

      {isDocumentSigned === "full" && (
        <div
          className={cx(
            style["text-center"],
            style["d-flex"],
            style["flex-column"],
            style["align-items-center"],
            style["mt-n2"]
          )}>
          <div className={cx(style["greenBox-icon"], style["mb-3"])}>
            <Icon icon="thumb-fill"></Icon>
          </div>
          <h4 className={cx(style["fw-7"], style["mb-4"])}>The Document is Accepted</h4>
          <p className={cx(style["font-15"], style["d-flex"])}>
            Accepted on<>&nbsp;</>
            <DataFormatter
              type="date-time"
              slug="signed_on"
              data={props?.signedDate}
              format="default"
              showBlank={true}
            />
          </p>
          <p className={style["font-15"]}>
            The document is locked and can’t be edited. The viewers can still access the published page.
          </p>
        </div>
      )}

      {isDocumentSigned === "declined" && (
        <div
          className={cx(
            style["text-center"],
            style["d-flex"],
            style["flex-column"],
            style["align-items-center"],
            style["mt-n2"]
          )}>
          <div className={cx(style["greenBox-icon"], style["mb-3"], style["error"])}>
            <Icon icon="thumb-fill"></Icon>
          </div>
          <h4 className={cx(style["fw-7"], style["mb-4"])}>The Document is Declined</h4>
          <p className={cx(style["font-15"], style["d-flex"])}>
            Declined on<>&nbsp;</>
            <DataFormatter
              type="date-time"
              slug={props?.signedDate?.declined_on ? "declined_on" : "expired_on"}
              data={props.signedDate}
              format="default"
              showBlank={true}
            />
          </p>
          <p className={style["font-15"]}>
            The document is locked and can’t be edited. The viewers can’t access the content of the published page.
          </p>
        </div>
      )}
    </React.Fragment>
  );
};
SignatureStatusModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  signerList: PropTypes.obj,
  signedDate: PropTypes.string,
};

export default SignatureStatusModal;
